// App.js
import React, { useState, useEffect } from 'react';
import netlifyIdentity from 'netlify-identity-widget';
import Home from './components/Home';
import Timer from './components/Timer';
import './App.css';

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [chatGPTOutput, setChatGPTOutput] = useState(null);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        netlifyIdentity.init();

        const checkAndSetUser = async () => {
            const currentUser = netlifyIdentity.currentUser();
            if (currentUser) {
                try {
                    await currentUser.jwt();
                    setUser(currentUser);
                } catch (error) {
                    console.error("Token refresh failed:", error);
                    netlifyIdentity.logout();
                    setUser(null);
                }
            }
            setLoading(false);
            // Trigger animation after a short delay
            setTimeout(() => setAnimate(true), 100);
        };

        checkAndSetUser();

        netlifyIdentity.on('login', user => {
            setUser(user);
            netlifyIdentity.close();
        });

        netlifyIdentity.on('logout', () => {
            setUser(null);
            setChatGPTOutput(null);
        });

        return () => {
            netlifyIdentity.off('login');
            netlifyIdentity.off('logout');
        };
    }, []);

    if (loading) {
        return <div className="app loading">Loading...</div>;
    }

    if (!user) {
        return (
            <div className={`app login-screen ${animate ? 'animate' : ''}`}>
                <div className="left-half">
                    <div className="content-wrapper">
                        <h1 className="title">GetStuffDone.</h1>
                        <h2 className="subtitle">Focus Sessions. No Fluff.</h2>
                        <button onClick={() => netlifyIdentity.open('login')} className="login-button">Log In</button>
                    </div>
                </div>
                <div className="right-half">
                    <img src="/ss.png" alt="Screenshot" className="screenshot" />
                </div>
            </div>
        );
    }

    return (
        <div className="app">
            <button className="logout-button" onClick={() => netlifyIdentity.logout()}>Logout</button>
            {!chatGPTOutput ? (
                <Home onFetchSuccess={(result) => setChatGPTOutput(result)} />
            ) : (
                <Timer chatGPTOutput={chatGPTOutput} />
            )}
        </div>
    );
}

export default App;
